import { Trans } from '@lingui/react/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
export function SelectWorkflow(props) {
    const { matchedWorkflows, onSelect } = props;
    if (matchedWorkflows.length === 1) {
        return (<Button $stretch appearance="primary" size="small" onClick={() => onSelect(matchedWorkflows[0].id)}>
        <Falcon icon="sparkles"/>
        <Trans comment="Document approval check - Run approval check button label">Run approval check</Trans>
      </Button>);
    }
    return (<Menu.Root target={<Button $stretch appearance="primary" size="small">
          <Falcon icon="sparkles"/>
          <Trans comment="Document approval check - Run approval check button label">Run approval check</Trans>
        </Button>}>
      <Menu.Label>
        <Trans comment="Document approval check - Select workflow menu label">Select workflow</Trans>
      </Menu.Label>

      {matchedWorkflows.map((workflow) => (<Menu.Item key={workflow.id} onClick={() => onSelect(workflow.id)}>
          {workflow.name}
        </Menu.Item>))}
    </Menu.Root>);
}
